var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "VisitorMediaAndDocuments" } }, [
    _vm.loading
      ? _c("div", { staticClass: "loading-container" }, [
          _c("div", { staticClass: "loading-spinner" }),
        ])
      : _c("div", { staticClass: "media-container" }, [
          _c("div", { staticClass: "header-section" }, [
            _c(
              "div",
              { staticClass: "tab-menu" },
              _vm._l(_vm.tabs, function (tab, index) {
                return _c(
                  "button",
                  {
                    key: index,
                    class: ["tab-btn", { active: _vm.activeTab === tab.id }],
                    on: {
                      click: function ($event) {
                        return _vm.handleTabClick(tab.id)
                      },
                    },
                  },
                  [
                    _c("i", { class: tab.icon }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(tab.name))]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.selectedImages.length > 0 || _vm.selectedFiles.length > 0
              ? _c("div", { staticClass: "selection-info" }, [
                  _c("span", { staticClass: "selection-count" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.activeTab === "images"
                            ? _vm.selectedImages.length
                            : _vm.selectedFiles.length
                        ) +
                        "\n                    " +
                        _vm._s("seçili") +
                        "\n                "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.activeTab === "images"
            ? _c("div", { staticClass: "content-wrapper" }, [
                _vm.images.length === 0
                  ? _c("div", { staticClass: "empty-state" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("p", { staticClass: "empty-text" }, [
                        _vm._v(_vm._s(_vm.$t("message.noMediaDocuments"))),
                      ]),
                    ])
                  : _c(
                      "div",
                      [
                        _c("transition", { attrs: { name: "slide-down" } }, [
                          _vm.selectedImages.length > 0
                            ? _c("div", { staticClass: "action-bar" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "download-button",
                                    attrs: { disabled: _vm.isDownloading },
                                    on: { click: _vm.downloadSelectedImages },
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-download" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isDownloading
                                            ? _vm.downloadProgress
                                            : _vm.$t("message.download")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "image-grid" },
                          _vm._l(_vm.images, function (image, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: [
                                  "image-card",
                                  {
                                    selected: _vm.selectedImages.includes(
                                      image.url
                                    ),
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.show(index)
                                  },
                                },
                              },
                              [
                                _c(
                                  "viewer",
                                  {
                                    attrs: {
                                      images: _vm.images.map(function (img) {
                                        return img.url
                                      }),
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "checkbox-wrapper",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "custom-checkbox",
                                          attrs: {
                                            type: "checkbox",
                                            id: "img-check-" + index,
                                            disabled:
                                              (_vm.isSelectionLimitReached &&
                                                !_vm.selectedImages.includes(
                                                  image.url
                                                )) ||
                                              _vm.isDownloading,
                                          },
                                          domProps: {
                                            checked:
                                              _vm.selectedImages.includes(
                                                image.url
                                              ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleImageSelection(
                                                image.url
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "checkbox-label",
                                          attrs: { for: "img-check-" + index },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "image",
                                      attrs: {
                                        id: "img-" + index,
                                        src: image.url,
                                        alt: image.name,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "image-overlay" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "overlay-content" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fas fa-search-plus zoom-icon",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "image-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.truncateFileName(
                                                      image.name,
                                                      20
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTab === "files"
            ? _c("div", { staticClass: "content-wrapper" }, [
                _vm.files.length === 0
                  ? _c("div", { staticClass: "empty-state" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("p", { staticClass: "empty-text" }, [
                        _vm._v(_vm._s(_vm.$t("message.noMediaDocuments"))),
                      ]),
                    ])
                  : _c(
                      "div",
                      [
                        _c("transition", { attrs: { name: "slide-down" } }, [
                          _vm.selectedFiles.length > 0
                            ? _c("div", { staticClass: "action-bar" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "download-button",
                                    attrs: { disabled: _vm.isDownloading },
                                    on: { click: _vm.downloadSelectedFiles },
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-download" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isDownloading
                                            ? _vm.downloadProgress
                                            : _vm.$t("message.download")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "file-list" },
                          _vm._l(_vm.files, function (file, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: [
                                  "file-card",
                                  {
                                    selected: _vm.selectedFiles.includes(
                                      file.url
                                    ),
                                  },
                                ],
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "checkbox-wrapper",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                  },
                                  [
                                    _c("input", {
                                      staticClass: "custom-checkbox",
                                      attrs: {
                                        type: "checkbox",
                                        id: "file-check-" + index,
                                        disabled:
                                          (_vm.isSelectionLimitReached &&
                                            !_vm.selectedFiles.includes(
                                              file.url
                                            )) ||
                                          _vm.isDownloading,
                                      },
                                      domProps: {
                                        checked: _vm.selectedFiles.includes(
                                          file.url
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.toggleFileSelection(
                                            file.url
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      staticClass: "checkbox-label",
                                      attrs: { for: "file-check-" + index },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "file-icon-wrapper",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openFile(file.url)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-alt file-icon",
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "file-info",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openFile(file.url)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "file-name",
                                        attrs: { title: file.name },
                                      },
                                      [_vm._v(_vm._s(file.name))]
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "file-size" }, [
                                      _vm._v(_vm._s(file.size)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "file-action-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openFile(file.url)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-external-link-alt",
                                    }),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-icon" }, [
      _c("i", { staticClass: "fas fa-images" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-icon" }, [
      _c("i", { staticClass: "fas fa-folder-open" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }